// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "customer." + chunkId + "." + {"libs_customer_customer-inventory-v1_src_index_ts":"88eac845aa445255","libs_customer_customer-documents-v1_src_index_ts":"62af1eb8aa467961","libs_customer_customer-approvals-v1_src_index_ts":"4259034be6d045dc"}[chunkId] + ".js";
};